import React from "react";
import Dialog from "components/platform/Dialog";
import { HeaderTitle } from "components/platform/Pages";
import {FormattedMessage} from "react-intl";
import { VtPlayer } from "./InterviewModal";

export const InterviewVideoModal = ({ onClose, interviewId }: any) => {
  return (
    <Dialog
      modal
      opened
      onClose={onClose}
      header={<HeaderTitle title={<FormattedMessage id="interview.video" />} />}
      width={600}
    >
      <div style={{ minHeight: "18.75rem", display: "flex", alignItems: "stretch", padding: 10, borderRadius: '1rem' }}>
        <VtPlayer interviewId={interviewId} />
      </div>
    </Dialog>
  )
}
